import React from 'react'
import { CiCircleCheck } from "react-icons/ci";
import { RxCrossCircled } from "react-icons/rx";
const ServiceTable = ({ pinCodeDetail }) => {
  return (
    <div className='mt-6 overflow-hidden rounded-[24px] border border-slate-200 bg-white shadow-[0_18px_42px_rgba(15,23,42,0.07)]'>
      <div className='border-b border-slate-100 px-6 py-5'>
        <p className='text-[10px] font-[GilroyBold] uppercase tracking-[0.18em] text-[#f97316]'>Result</p>
        <h3 className='mt-2 text-[1.2rem] font-[GilroyBold] text-slate-950'>{pinCodeDetail.Pin} is serviceable</h3>
        <p className='mt-1 text-sm font-[GilroyMedium] text-slate-500'>Coverage details for the selected destination pin code are listed below.</p>
      </div>

      <div className='overflow-x-auto'>
        <div className='grid min-w-[720px] grid-cols-5 bg-[#fffaf6] px-6 py-4 text-xs font-[GilroyBold] uppercase tracking-[0.14em] text-[#bf7b52]'>
          <p>Pin Code</p>
          <p>State</p>
          <p>City</p>
          <p>Service</p>
          <p>ODA</p>
        </div>
        <div className='grid min-w-[720px] grid-cols-5 px-6 py-5 text-sm font-[GilroyMedium] text-slate-700'>
          <p>{pinCodeDetail?.Pin}</p>
          <p>{pinCodeDetail?.FacilityState}</p>
          <p>{pinCodeDetail?.FacilityCity}</p>
          <p className="text-[1.5rem] text-green-600"><CiCircleCheck /></p>
          <p>{pinCodeDetail.ODA === "ODA" ? <CiCircleCheck className="text-[1.5rem] text-green-600" /> : <RxCrossCircled className="text-[1.5rem] text-red-600" />}</p>
        </div>
      </div>
    </div>
  )
}

export default ServiceTable
